<template>
  <v-form v-model="valid">
    <building-complex-form
      v-model="form"
      :readonly="!editMode"
      :action="editMode ? 'edit' : 'show'"
      :errors="errors.getAll()"
      @update-prop="clearErrorByName($event)"
    >
    </building-complex-form>
    <v-row dense>
      <v-col cols="12" class="pt-0">
        <div v-if="editMode">
          <v-btn
            outlined
            class="mr-5"
            depressed
            color="grey"
            large
            @click="cancel"
          >
            {{ $t('BUTTON.CANCEL') }}
          </v-btn>
          <v-btn
            depressed
            type="submit"
            :disabled="!valid"
            large
            color="primary"
            class="mr-5"
            @click.prevent="updateBuildingComplex"
          >
            {{ $t('BUTTON.UPDATE') }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import { cloneDeep, isEqual } from 'lodash';
import BuildingComplexForm from '@/modules/building_complexes/components/forms/BuildingComplexForm';
import { BuildingComplexesService } from '@/services/building-complexes.service';

export default {
  name: 'BuildingComplexEdit',

  components: { BuildingComplexForm },

  mixins: [errors],

  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      form: {},
      valid: false,
      formCopy: null
    };
  },

  watch: {
    editMode: {
      deep: true,
      immediate: true,
      handler: function(v) {
        if (v) {
          this.formCopy = cloneDeep(this.form);
        }
      }
    },

    value: {
      deep: true,
      immediate: true,
      handler: function(formProps) {
        if (isEqual(formProps, this.form)) {
          return;
        }

        this.form = {
          ...this.form,
          ...formProps
        };

        this.emitter();
      }
    }
  },

  methods: {
    emitter() {
      this.$emit('input', this.form);
    },

    cancel() {
      this.form = cloneDeep(this.formCopy);
      this.$emit('cancel');
    },

    updateBuildingComplex() {
      BuildingComplexesService.update(this.form.id, this.form)
        .then(({ data }) => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$emit('update', data);
        })
        .catch(this.handleErrors);
    }
  }
};
</script>

<style scoped></style>
